import React, {useEffect} from "react";
import {useLocation} from "react-router";
import PageSection from "../elements/PageSection";
import styled from "styled-components";
import {borderColour, subduedTextColour, triggerColour} from "../../style/styleConsts";
import {supportEmail} from "../../config";
import {log} from "../../logging/logEvent";

const Heading = styled.h1`
  margin: 60px 0;
`;

const A = styled.a`
  color: ${triggerColour};
`;

const Status = styled.span`
  color: ${subduedTextColour};
  border-right: 1px solid ${borderColour};
  padding: 15px 15px 15px 0;
  margin-right: 10px;
`;

const NotFoundPage = ({}) => {
    const location = useLocation();
    useEffect(() => {
        const path = location && location.pathname;
        log("PageNotFound", { path: path });
    }, []);

    return (
        <PageSection>
            <Heading><Status>404</Status> Page Not Found</Heading>
            <p>We may have moved that page. To find what you're looking for, you can try:</p>
            <ul>
                <li>Searching in the box above</li>
                <li>Clicking one of the main menu options</li>
            </ul>
            <p>
                If those aren't helpful, please email <A href={`mailto:${supportEmail}`}>{supportEmail}</A> and one of our team will get back to you.
            </p>
        </PageSection>
    )
};

export default NotFoundPage;
